import { Component, ViewChild } from '@angular/core';
import { SingleInsurantFormComponent } from 'app/order/components/single-insurant-form/single-insurant-form.component';
import { Insurant } from '@models/insurant';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models/order-state.model';

@Component({
    selector: 'app-single-insurant',
    templateUrl: './single-insurant.component.html',
    styleUrls: ['./single-insurant.component.scss'],
    standalone: false,
})
export class SingleInsurantComponent extends OrderStepBaseComponent<
    Pick<OrderState, 'insurants' | 'insurantsFamilyRelationship'>
> {
    @ViewChild(SingleInsurantFormComponent)
    private singleInsurantForm: SingleInsurantFormComponent;

    public get insurants(): Insurant[] | undefined {
        return this.state?.insurants;
    }

    public getData(): Pick<OrderState, 'insurants' | 'insurantsFamilyRelationship'> {
        return this.singleInsurantForm?.getData();
    }

    public override get isInvalid(): boolean {
        return this.singleInsurantForm?.isInvalid;
    }
}
